import liff from '@line/liff';
import { PROFILE_CACHE_DURATION } from '../constants';

/**
 * LIFFを初期化する
 */
export const initializeLiff = async (liffId) => {
  try {
    await liff.init({
      liffId: liffId,
      // 外部ブラウザで自動ログインを無効化して非ログイン状態でのURLからのアプリ閲覧を許可
      withLoginOnExternalBrowser: false,
    });
    console.log('LIFF initialized successfully');
    
    // プロフィールの取得はuseLiffフックに任せる
    // 初期化のみを行い、プロフィール取得は行わない
    
    return true;
  } catch (error) {
    console.error('Failed to initialize LIFF', error);
    return false;
  }
};

/**
 * ユーザープロファイルを取得
 * @param {boolean} forceRefresh キャッシュを無視して再取得するかどうか
 */
export const getProfile = async (forceRefresh = false) => {
  try {
    if (!liff.isLoggedIn()) {
      throw new Error('User is not logged in');
    }
    
    // キャッシュから取得（forceRefreshがfalseの場合）
    if (!forceRefresh) {
      try {
        const cachedProfileString = localStorage.getItem('user_profile');
        if (cachedProfileString) {
          const cachedProfile = JSON.parse(cachedProfileString);
          
          // キャッシュが24時間以内なら使用
          const lastLoginTime = new Date(cachedProfile.lastLogin).getTime();
          const currentTime = new Date().getTime();
          if (currentTime - lastLoginTime < PROFILE_CACHE_DURATION) {
            console.log('Using cached profile from services/liff.js');
            return cachedProfile;
          }
        }
      } catch (cacheError) {
        console.error('Error reading from cache', cacheError);
        // キャッシュエラーは無視して続行
      }
    }
    
    // APIから取得
    const profile = await liff.getProfile();
    
    // プロフィールをローカルストレージに保存
    localStorage.setItem('user_profile', JSON.stringify({
      userId: profile.userId,
      displayName: profile.displayName || '',
      pictureUrl: profile.pictureUrl || '',
      statusMessage: profile.statusMessage || '',
      lastLogin: new Date().toISOString()
    }));
    console.log('User profile saved to localStorage from services/liff.js');
    
    return profile;
  } catch (error) {
    console.error('Failed to get profile', error);
    throw error;
  }
};

/**
 * LINEログインを実行
 */
export const login = () => {
  // 現在のURLをリダイレクト先に指定
  const redirectUri = window.location.origin + window.location.pathname;
  liff.login({
    redirectUri: redirectUri
  });
};

/**
 * LINEでシェアする
 */
export const shareContent = async (text) => {
  try {
    if (!liff.isInClient()) {
      throw new Error('Not in LINE client');
    }
    
    const result = await liff.shareTargetPicker([
      {
        type: 'text',
        text
      }
    ]);
    
    return !!result;
  } catch (error) {
    console.error('Failed to share content', error);
    throw error;
  }
};

/**
 * 環境チェック関数
 */
export const isInClient = () => liff.isInClient();
export const isLoggedIn = () => liff.isLoggedIn();
export const isReady = () => liff.isReady();